import { useEffect } from "react";

export function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("in"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" },
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

export function scrollToConfigure(e) {
  if (e && e.preventDefault) e.preventDefault();
  scrollToId("configure", 96);
}

/**
 * Header-aware smooth scroll to an element by id. `extraOffset` is added
 * on top of the sticky header height so the destination clears the fold.
 */
export function scrollToId(id, extraOffset = 96) {
  const el = document.getElementById(id);
  if (!el) return;
  const header = document.querySelector("header");
  const headerH = header ? header.getBoundingClientRect().height : 88;
  const y = el.getBoundingClientRect().top + window.scrollY - headerH + extraOffset;
  window.scrollTo({ top: y, behavior: "smooth" });
}
